import React from "react";

const employeeDirectoryRows = [
  {
    serial: "01",
    name: "Dr. Abha Rani Singh, IRS",
    designation: "Chairman-cum-Managing Director",
    contact: "+91-11-22441635",
    email: "cmd.nmdfc[at]gmail.com",
  },
  {
    serial: "02",
    name: "Sh Anil Kumar",
    designation: "General Manager (Project / Legal & Recovery)",
    contact: "+91-11-22460253",
    email: "a.kumar28[at]nic.in",
  },
  {
    serial: "03",
    name: "Sh. Kumar Sudesh",
    designation: "General Manager (Fin. And Coordination)",
    contact: "+91-11-22441438",
    email: "k.sudesh27[at]nic.in",
  },
  {
    serial: "04",
    name: "Sh Nixon Mathur",
    designation:
      "General Manager (Planning/Social Media)/Chief Vigilance Officer",
    contact: "+91-11-22441435",
    email: "n.mathur28[at]nic.in",
  },
  {
    serial: "05",
    name: "Sh Manoj Punia",
    designation: "General Manager ( Accounts/Marketing)",
    contact: "+91-11-22040667",
    email: "m.punia29[at]nic.in",
  },
  {
    serial: "06",
    name: "Sh P.S. Pawnikar",
    designation: "Dy. Gen. Manager (System & Skill Dev./OL/Records Mngt./H&A)",
    contact: "+91-11-22441453",
    email: "ps.pawnikar29[at]nic.in",
  },
  {
    serial: "07",
    name: "Sh. Sachin Kumar",
    designation: "Asst. Gen. Manager (Finance/Planning)",
    contact: "+91-11-22441442",
    email: "s.kumar41[at]nic.in",
  },
  {
    serial: "08",
    name: "Sh. D. Das",
    designation: "Asst. Gen. Manager (H&A) / PIO",
    contact: "+91-11-22441455",
    email: "d.das27[at]nic.in",
  },
  {
    serial: "09",
    name: "Sh. Jauedul Hasan",
    designation: "Asst. Gen. Manager (Accounts)",
    contact: "+91-11-22441442",
    email: "j.hasan39[at]nic.in",
  },
  {
    serial: "10",
    name: "Sh. S.M. Jha",
    designation: "Manager (Coordination/ Records Management)",
    contact: "+91-11-22441442",
    email: "sm.jha31[at]nic.in",
  },
  {
    serial: "11",
    name: "Sh. Pradeep Kr. Gupta",
    designation: "Manager (Official Language/Marketing)",
    contact: "+91-11-22441442",
    email: "pradeepgupta111[at]yahoo.co.in",
  },
  {
    serial: "12",
    name: "Sh. Harish Sharma",
    designation: "Manager (Pub. & Social Media/CSR)",
    contact: "+91-11-22441442",
    email: "h.sharma51[at]nic.in",
  },
  {
    serial: "13",
    name: "Sh. Vikas Khatri",
    designation: "Dy. Manager (Accounts)",
    contact: "+91-11-22441442",
    email: "vk.nmdfc[at]gmail.com",
  },
  {
    serial: "14",
    name: "Sh. Narendra Kumar Nitharwal",
    designation: "Dy. Manager (Finance/ Legal & Recovery)",
    contact: "+91-11-22441442",
    email: "nk.nmdfc[at]gmail.com",
  },
  {
    serial: "15",
    name: "Sh. Rajan Yadav",
    designation: "Dy. Manager (Systems & Skill Dev.)",
    contact: "+91-11-22441442",
    email: "r.yadav53[at]nic.in",
  },
  {
    serial: "16",
    name: "Smt. Sharmeen Qureshi",
    designation: "Dy. Manager (Accts)",
    contact: "+91-11-22441442",
    email: "sharmeenq30[at]govcontractor.in",
  },
  {
    serial: "17",
    name: "Sh. Vipin Nijhawan",
    designation: "Dy. Manager (Project / Legal & Recovery)",
    contact: "+91-11-22441442",
    email: "vip_nijh[at]rediffmail.com",
  },
  {
    serial: "18",
    name: "Sh. Dharmender Kumar",
    designation: "Dy. Manager (Fin.)",
    contact: "+91-11-22441442",
    email: "d.kumar30[at]nic.in",
  },
  {
    serial: "19",
    name: "Sh. Vinod Kumar Prajapati",
    designation: "Dy. Manager(Systems)",
    contact: "+91-11-22441442",
    email: "v.prajapati41[at]nic.in",
  },
  {
    serial: "20",
    name: "Sh. Sushil Saini",
    designation: "Dy. Manager (H&A/ Project/Planning)",
    contact: "+91-11-22441442",
    email: "saini.sushil73[at]gmail.com",
  },
  {
    serial: "21",
    name: "Sh. Brij Mohan",
    designation: "Assistant Manager(CMD-Sectt)",
    contact: "+91-11-22441635",
    email: "nmdfc.brij[at]gmail.com",
  },
  {
    serial: "22",
    name: "Smt. Urmila Kumari",
    designation: "Assistant Manager(CS)",
    contact: "+91-11-22441442",
    email: "u.kumari35[at]nic.in",
  },
  {
    serial: "23",
    name: "Sh. Samson Messy",
    designation: "Supervisor (Admin)",
    contact: "+91-11-22441442",
    email: "nmdfcsamson[at]gmail.com",
  },
  {
    serial: "24",
    name: "Sh. Anand Prasad",
    designation: "Supervisor (Admin)",
    contact: "+91-11-22441442",
    email: "anandprasad197[at]gmail.com",
  },
  {
    serial: "25",
    name: "Sh. Shankar Ram",
    designation: "Supervisor (Planning)",
    contact: "+91-11-22441442",
    email: "nmdfcram[at]gmail.com",
  },
  {
    serial: "26",
    name: "Sh. Mohan Ram",
    designation: "Supervisor (Accounts)",
    contact: "+91-11-22441442",
    email: "mohan_197010[at]yahoo.in",
  },
  {
    serial: "27",
    name: "Miss. Komal",
    designation: "Supervisor (Planning)",
    contact: "+91-11-22441442",
    email: "k.komal54[at]govcontractor.in\nkomal.nmdfc[at]gmail.com",
  },
  {
    serial: "28",
    name: "Sh. Mansingh Meena",
    designation: "Supervisor (Projects)",
    contact: "+91-11-22441442",
    email: "mansinghsattawan[at]gmail.com",
  },
  {
    serial: "29",
    name: "Sh. Pankaj Kumar Arya",
    designation: "Supervisor (H&A/S&SD)",
    contact: "+91-11-22441442",
    email: "pankajnmdfc1994[at]gmail.com",
  },
  {
    serial: "30",
    name: "Sh. Ashok Saini",
    designation: "Assistant",
    contact: "+91-11-22441442",
    email: "aKSaini180371[at]gmail.com",
  },
  {
    serial: "31",
    name: "Sh. Gangaram Gautam",
    designation: "Assistant",
    contact: "+91-11-22441442",
    email: "nmdfcganga[at]gmail.com",
  },
  {
    serial: "32",
    name: "Sh. Sher Bahadur",
    designation: "Assistant",
    contact: "+91-11-22441442",
    email: "sherbhadur8800[at]gmail.com",
  },
  {
    serial: "33",
    name: "Sh. Sheetla Prasad",
    designation: "Assistant",
    contact: "+91-11-22441442",
    email: "sheetlanmdfc[at]gmail.com",
  },
  {
    serial: "34",
    name: "Sh. Prem Chand",
    designation: "Junior Assistant",
    contact: "+91-11-22441442",
    email: "-",
  },
  {
    serial: "35",
    name: "Sh. Gourav Gautam",
    designation: "Junior Assistant",
    contact: "+91-11-22441442",
    email: "gauravgautam8445[at]gmail.com",
  },
];

const ChapterTenContent = () => (
  <article className="min-w-0 flex-1 px-1 pb-8 font-sans text-[#001b33]">
    <h2 className="mb-6 text-[20px] font-bold leading-7 text-[#006461]">
      Chapter 10 : Directory of officers and employees [SECTION 4(1)(B)(ix)]
    </h2>

    <section className="rounded-[18px] bg-white p-4 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
      <div className="overflow-hidden rounded-xl">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[840px] table-fixed border-collapse text-[14px] leading-5">
            <colgroup>
              <col className="w-[58px]" />
              <col className="w-[175px]" />
              <col />
              <col className="w-[150px]" />
              <col className="w-[205px]" />
            </colgroup>
            <thead>
              <tr className="bg-[#dce9fb] text-left text-[14px] font-bold text-[#001b33]">
                <th className="rounded-l-[8px] px-4 py-3">S.No.</th>
                <th className="px-4 py-3">Employee Name</th>
                <th className="px-4 py-3">Designation</th>
                <th className="px-4 py-3">Contact No.</th>
                <th className="rounded-r-[8px] px-4 py-3">Email ID</th>
              </tr>
            </thead>
            <tbody>
              {employeeDirectoryRows.map((row, index) => (
                <tr
                  key={row.serial}
                  className={`border-b border-[#d7dde4] last:border-b-0 ${
                    index % 2 === 0 ? "bg-white" : "bg-[#f6f9fc]"
                  }`}
                >
                  <td className="px-4 py-3 align-middle font-medium">
                    {row.serial}
                  </td>
                  <td className="px-4 py-3 align-middle font-medium">
                    {row.name}
                  </td>
                  <td className="px-4 py-3 align-middle font-medium">
                    {row.designation}
                  </td>
                  <td className="px-4 py-3 align-middle font-medium">
                    {row.contact}
                  </td>
                  <td className="whitespace-pre-line break-words px-4 py-3 align-middle font-medium">
                    {row.email}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </article>
);

export default ChapterTenContent;
